/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface SeekToOffset$Params {
  containerId: string;
  topic: string;
  partition: number;
  offset: number;
}

export function seekToOffset(
  http: HttpClient,
  rootUrl: string,
  params: SeekToOffset$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, seekToOffset.PATH, 'post');
  if (params) {
    rb.path('containerId', params.containerId, {});
    rb.path('topic', params.topic, {});
    rb.path('partition', params.partition, {});
    rb.query('offset', params.offset, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    }),
  );
}

seekToOffset.PATH = '/manage/messaging/{containerId}/{topic}/{partition}/seekToOffset';
